const en = {
  language: {
    label: "Language",
    english: "English",
    arabic: "Arabic",
  },
  common: {
    logout: "Logout",
    orders: "orders",
  },
  vendor: {
    menu: {
      vendorDashboard: "Vendor Dashboard",
      users: "Users",
      drivers: "Drivers",
      vendorOrders: "Vendor Orders",
      configuration: "Configuration",
      vendorConfiguration: "Vendor Configuration",
      pricing: "Pricing",
      godsEye: "God's Eye",
    },
    dashboard: {
      overviewTitle: "Vendor Dashboard Overview",
      deliveryPerformance: "Delivery Performance",
      topMerchants: "Top 5 Merchants",
      orderStatusOverview: "Order Status Overview",
      logisticsMovement: "Logistics Movement",
      movements: "Movements",
      orders: "Orders",
      confirmed: "Confirmed",
      pickedUp: "Picked Up",
      onDelivery: "On Delivery",
      delivered: "Delivered",
      cancelled: "Cancelled",
      returned: "Returned",
      failed: "Failed",
      arrived: "Arrived",
      departed: "Departed",
      inTransit: "In Transit",
      merchantA: "Merchant A",
      merchantB: "Merchant B",
      merchantC: "Merchant C",
      merchantD: "Merchant D",
      merchantE: "Merchant E",
    },
    kpi: {
      drivers: "Drivers",
      totalOrders: "Total Orders",
      returnedOrders: "Returned Orders",
      totalCollected: "Total Collected",
      codFee: "COD Fee",
      vendorPayable: "Vendor Payable",
      pending: "Pending",
      confirmed: "Confirmed",
      pickedUp: "Picked Up",
      onDelivery: "On Delivery",
      delivered: "Delivered",
      cancelled: "Cancelled",
      returnRequested: "Return Requested",
      returnAssigned: "Return Assigned",
      returnPickedUp: "Return Picked Up",
      returnOnDelivery: "Return On Delivery",
      returned: "Returned",
    },
  },
};

export default en;
